<template>
  <v-row justify="center">
    <v-col style="max-width: 540px !important">
      <v-row no-gutters align="center" justify="start" v-if="$store.state.payments.retrieveLoader">
        <v-col cols="12">
          <v-boilerplate type="image, article" />
          <v-skeleton-loader />
        </v-col>
      </v-row>
      <v-card min-width="350" v-else>
        <v-card-title class="py-4 text-center" v-if="source.account.logo">
          <v-spacer />
          <v-sheet rounded outlined>
            <v-responsive class="align-center" :aspect-ratio="1/1">
              <v-sheet class="px-1" width="100">
                <v-img :src="source.account.logo" width="100%" />
              </v-sheet>
            </v-responsive>
          </v-sheet>
          <v-spacer />
        </v-card-title>
        <v-card-subtitle class="py-4">
          <v-row>
            <v-col class="text-center" cols="12">
              <span class="d-block body-2 text--secondary font-weight-medium">{{source.account.name}}</span>
              <span class="d-block body-1 text--secondary font-weight-medium">{{source.description}}</span>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="px-0 background">
          <v-row class="px-4" no-gutters>
            <v-col cols="12" class="pt-1 pb-5 text-center">
              <span class="d-block body-2">Registra tu tarjeta para completar el proceso</span>
            </v-col>
            <v-col cols="12">
              <v-row class="mx-0" align="center" justify="start" no-gutters>
                <v-col cols="12" class="px-0">
                  <template v-if="source.gateway === 'stripe'">
                    <gateway-stripe ref="stripe" :test-mode="source.test_mode" />
                  </template>
                </v-col>
                <v-col cols="12" class="px-0 mt-6">
                  <v-btn @click="storeSource" block :color="source.account.color_background" dark height="40" :loading="loaderStore">Registrar tarjeta</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <piriod-sign />
    </v-col>
  </v-row>
</template>
<script>
// libs
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'

// mixins
import GenericViewMixin from '@/mixins/GenericViewMixin'

// components
import GatewayStripe from '@/components/GatewayStripe'
import PiriodSign from '@/components/PiriodSign'

export default {
  inject: ['theme'],
  components: {
    GatewayStripe,
    PiriodSign,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    loaderStore: false
  }),
  computed: mapState({
    source: state => cloneDeep(state.payments.sourcesDetail)
  }),
  created () {
    this.$store.dispatch('payments/RETRIEVE', {
      resource: 'publishable/sources',
      id: this.$route.params.id
    })
    .catch((error) => {
      if (error.response.status === 404) {
        this.$router.push({ name: 'PageExpired' })
      }
    })
  },
  methods: {
    async storeSource () {
      this.loaderStore = true

      const token = await this.$refs[this.source.gateway].send()

      // store the source using the token
      try {
        await this.$store.dispatch('payments/CREATE', {
          resource: 'sources',
          id: this.$route.params.id,
          detail: 'store',
          payload: {
            token: token
          }
        })
      } catch (e) {
        // handle error and redirect to error page or show error message
        if (this.source.return_url) {
          window.location.href = this.source.return_url + `?error=${encodeURIComponent(e.message)}`
        } else {
          this.$router.push({ name: 'SourceStoreError' })
        }
        return
      } finally {
        this.loaderStore = false
      }

      // redirect to success page or redirect to custom URL
      if (this.source.return_url) {
        window.location.href = this.source.return_url + `?success=true`
      } else {
        this.$router.push({ name: 'SourceStoreSuccess' })
      }
    }
  }
}
</script>